import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=6217ca5a&scoped=true&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=6217ca5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6217ca5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6217ca5a')) {
      api.createRecord('6217ca5a', component.options)
    } else {
      api.reload('6217ca5a', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=6217ca5a&scoped=true&", function () {
      api.rerender('6217ca5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/chart-of-account/IndexPage.vue"
export default component.exports